import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import authAtom, { isAuthInitializedAtom } from '../features/auth/authAtom';

interface Props {
  children: ReactElement;
}

// 未ログインユーザのみアクセスできるルート (/login など)
// localStorage などからのセッション初期化完了まではローディングを表示
const GuestRoute = ({ children }: Props): ReactElement => {
  const session = useAtomValue(authAtom); // null | session | undefined
  const initialized = useAtomValue(isAuthInitializedAtom); // boolean

  if (!initialized) {
    return <Spin />;
  }
  if (session) {
    return <Navigate to='/recordings' replace />;
  }
  return children;
};

export default GuestRoute;
